<template>
  <div>
    <ion-searchbar
      no-border
      v-ion-model="keywords"
      :debounce="600"
      @ionChange="search"
    ></ion-searchbar>

     <!-- <ion-list v-if="!keywords || keywords == ''">
          <ion-item button v-for="(key, idx) in $store.state.history.search.laws" :key="idx">
              {{key}}
          </ion-item>
      </ion-list> -->

    <ion-list>
      <ion-item v-if="count && keywords"
        >{{ count }} match<span v-if="count > 1">es</span>&nbsp;found.</ion-item
      >
      <ion-item
        detail
        button
        v-for="(c, idx) in result"
        :key="idx"
        :href="`#/digests/${c.id}`"
        @click="viewDoc($event, c)"
      >
        <ion-grid when="sm" style="width:100%">
          <ion-row>
            <ion-col size-sm="7" size="12">
              <h2 class="list-title" v-html="c.title"></h2>
            </ion-col>
            <ion-col size-sm="3" size="12">
              <p class="no-margin">
                <span v-for="(tag, idx) in c.tags" :key="idx">{{ tag }}</span>
              </p>
            </ion-col>
            <ion-col size-sm="2" size="12">
              <ion-note>{{ formatDate(c.created_at) }}</ion-note>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    </ion-list>

   <!-- <button @click="$router.push('/digests/edit')" class="floating-button ion-activatable">
      <ion-ripple-effect type="unbounded"></ion-ripple-effect>
      <ion-icon name="add"></ion-icon>
   </button> -->

    <ion-infinite-scroll
      ref="scoller"
      threshold="200px"
      @ionInfinite="loadNext"
    >
      <ion-infinite-scroll-content
        loadingSpinner="bubbles"
        loadingText="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>
</template>
<script>
import debounce from "debounce";
import { format } from "date-fns";

export default {
  data() {
    return {
      result: [],
      page: 0,
      keywords: "",
      count: 0,
      limits: 0,
      offset: 0,
      pages: 0
    };
  },

  methods: {
    async _search(append = false) {
      if (!append) {
        this.page = 0;
      }

      var params = {
        _project: ["id", "title", "created_at", "category", "tags"],
        _sort: "updated_at:desc",
        _page: this.page
      };

      if (this.keywords) {
        params.title_regex = this.keywords;
      }

      var res = await this.$lawyerly.digests.search(params);

      this.count = res.data.count;

      if (append && res.data.result) {
        this.result = [...this.result, ...res.data.result];
      } else {
        this.result = res.data.result;
      }

      this.limits = res.data.limits;
      this.offset = res.data.offset;
      this.pages = this.count / (this.limits || 1);
      this.$refs.scoller.disabled = this.page >= this.pages;
      this.$store.commit("ui/setLastDigestsQuery", this.keywords);
      this.$store.commit("history/addSearch", {key: this.keywords, type: "digests"});
    },

    async loadNext(evt) {
      this.page = this.page + 1;
      await this._search(true);
      evt.target.complete();
    },

    search: debounce(function() {
      this._search();
    }, 500),

    viewDoc(e, doc) {
      e.preventDefault();
      setTimeout(() => {
        this.$router.push(`digests/${doc.id}`);
      }, 350);
    },

    new() {
      this.$router.push("/digests/edit");
    },

    onHeaderCommand(event, cmd) {
      switch (cmd.cmd) {
        case "new":
          this.new();
          break;
      }
    },

    formatDate(date) {
      return format(new Date(date.replace(' ', 'T')), "MMM. dd, yyyy hh:mm a");
    }
  },

  mounted() {
    this.$store.commit("ui/setHeaderTitle", "Search Digests");
    this.keywords = this.$store.state.ui.setLastDigestsQuery;
    this._search();

    this.$store.commit("ui/setMoreHeaderButtons", {
      mobile: [],
      web: [
        { label: "new", icon: "add-circle", disabled: false, emit: "header-command", cmd: "new" },
      ]
    });
    this.$root.$on("header-command", this.onHeaderCommand);
  },

  beforeDestroy() {
    this.$store.commit("ui/setHeaderTitle", "");
    this.$store.commit("ui/setMoreHeaderButtons", {mobile: [], web: []});
    this.$root.$off("header-command", this.onHeaderCommand);
  }
};
</script>
<style>
h2.list-title {
  font-size: 14pt;
  margin: 0px;
}
b.hi {
  background-color: rgba(255, 255, 0, 0.2);
}
p.no-margin {
  margin: 0px 0.5em;
}

.floating-button {
  padding: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  position: fixed; 
  right: 10px; 
  bottom: 10px;
  background-color: rgb(23, 179, 145);
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}

.floating-button ion-icon {
  font-size: 2.3em;
  color: #fff;
}
</style>
